export const isDisabled = process.env.REACT_APP_DISABLE_ELEMENTS === 'true';
export const isHidden = process.env.REACT_APP_HIDDEN_ELEMENT === 'true';
